import * as Datas from "@data";
import {axiosPostUtil} from "./axiosUtil";

const api = {
  v1: {
    review: {
      getCount: async () => {
        return (await axiosPostUtil)<Datas.ApiResponse<number>>(
          "/api/v1/review/getCount",
        ).then(value => value.data);
      },

      getList: async ({
        page = 1,
        limit = 20,
        ...args
      }: {
        limit?: number;
        page?: number;
        searchTxt?: string;
      }) => {
        return (await axiosPostUtil)<
          Datas.ApiResponse<Datas.ResultPagingResponse<Datas.IReviewData>>
        >("/api/v1/review/getList", {
          ...args,
          page,
          limit,
        }).then(value => value.data);
      },
    },
  },
};

export default api;
